export class ApprovalDetailsRequestModel{
    creator_Email : boolean;
    approverApprovesCreator_Email : boolean;
    approverApprovesCreator_Cc : boolean;
    approverRejectsCreator_Email : boolean;
    approverRejectsCreator_Cc : boolean;
    isCreatorManager : boolean;
    manager_Email : boolean;
    manager_Cc : boolean;
    isPerson : boolean;
    personId : number;
    personId_Email : boolean;
    personId_Cc : boolean;
    isAdminSecurityLevel : boolean;
    adminSecurityLevelPerson_Email : boolean;
    adminSecurityLevelPerson_Cc : boolean;
    approverApprovesApprover_Email : boolean;
    approverApprovesApprover_Cc : boolean;
    approverRejectsApprover_Email : boolean;
    approverRejectsApprover_Cc : boolean;
    order : number;
}